import React, { Component, ReactElement } from "react";
import Tab from './Tab';

interface StateType {
    selected: string;
}


class Tabs extends Component<{}, StateType> {

    public state = {
        selected: '',
    };

    public componentDidMount() {
        this.setSelected();
    }

    public componentDidUpdate() {
        if (!this.state.selected) {
            this.setSelected();
        }
    }

    private setSelected() {
        if (this.props.children && Array.isArray(this.props.children) && this.props.children.length) {
            const tab = this.props.children[0];
            this.setState({selected: (tab as Tab).props.id});
        }
    }

    private renderNav(): ReactElement<any> {
        return (
            <ul className="nav nav-tabs">
                {this.props.children && Array.isArray(this.props.children) && this.props.children.map((tab: Tab) => {
                    return (
                        <li key={tab.props.id} className={this.state.selected === tab.props.id ? 'active' : ''}>
                            <a onClick={() => this.setState({selected: tab.props.id})}>
                                {tab.props.label} {tab.props.changed && <span>*</span>}
                            </a>
                        </li>
                    );
                })}
            </ul>
        );
    }

    public render() {
        return (
            <div className="tabs-container">
                {this.renderNav()}
                <div className="tab-content">
                    {this.props.children && Array.isArray(this.props.children) && this.props.children.find((tab: Tab) => tab.props.id === this.state.selected)}
                </div>
            </div>
        );
    }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tab/Tabs.tsx